import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { ApiService } from '@core/services/api.service';
import { SnackbarService } from '@core/services/snackbar.service';

@Component({
  standalone: true,
  selector: 'app-announcement-widget',
  imports: [CommonModule, MatIconModule],
  templateUrl: './announcement-widget.component.html',
  styleUrls: ['./announcement-widget.component.scss'],
})
export class AnnouncementWidgetComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  loading = true;
  items: any[] = [];
  unacknowledgedCount = 0;
  showModal = false;
  acking: Record<string, boolean> = {};

  constructor(private api: ApiService, private snackbar: SnackbarService) {}

  ngOnInit(): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.api.get('/announcements/mine').pipe(
      catchError(() => of({ items: [], unacknowledgedCount: 0 })),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res: any) => {
      this.items = res?.items || [];
      this.unacknowledgedCount = res?.unacknowledgedCount || 0;
      this.loading = false;
    });
  }

  get latest(): any { return this.items[0] || null; }

  open(): void { this.showModal = true; }
  close(): void { this.showModal = false; }

  acknowledge(item: any): void {
    if (item.acknowledged || this.acking[item.id]) return;
    this.acking[item.id] = true;
    this.api.post(`/announcements/${item.id}/acknowledge`, {}).pipe(
      catchError(() => of(null)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((res: any) => {
      this.acking[item.id] = false;
      if (!res) { this.snackbar.showFailure('Could not record your acknowledgement. Try again.'); return; }
      item.acknowledged = true;
      item.acknowledgedAt = res.acknowledgedAt;
      this.unacknowledgedCount = this.items.filter(i => !i.acknowledged).length;
      this.snackbar.showSuccess('Acknowledged.');
    });
  }

  priorityClass(p: string): string {
    if (p === 'high') return 'aw-p-high';
    if (p === 'medium') return 'aw-p-medium';
    return 'aw-p-normal';
  }

  priorityLabel(p: string): string {
    if (p === 'high') return 'High priority';
    if (p === 'medium') return 'Medium priority';
    return 'Normal';
  }
}
